import * as yup from 'yup';
import differenceInDays from 'date-fns/differenceInDays';
import { CreateSynchroForm } from '../../types';

const MAX_RANGE_DAYS = 31;

export const getSchema = (): yup.ObjectSchema<CreateSynchroForm> => {
  const schema = yup.object().shape({
    country: yup.string().required('El país es obligatorio'),
    stores: yup
      .array()
      .of(yup.object().required())
      .min(1, 'Debe seleccionar al menos una tienda')
      .required(),
    businessDateFrom: yup.date().required('Fecha desde es obligatoria').nullable(),
    businessDateTo: yup
      .date()
      .required('Fecha hasta es obligatoria')
      .nullable()
      .min(yup.ref('businessDateFrom'), "La fecha 'Hasta' debe ser posterior a 'Desde'")
      .test(
        'max-range-days',
        `El rango no puede superar los ${MAX_RANGE_DAYS} días`,
        function (businessDateTo) {
          const { businessDateFrom } = this.parent;
          if (!businessDateTo || !businessDateFrom) return true;

          const diff = Math.abs(differenceInDays(businessDateTo, businessDateFrom));
          return diff <= MAX_RANGE_DAYS;
        }
      ),
    justification: yup
      .string()
      .required('La justificación es obligatoria')
      .max(80, 'Máximo 80 caracteres'),
  });

  return schema as unknown as yup.ObjectSchema<CreateSynchroForm>;
};
